export default __webpack_public_path__ + "static/media/gold.cfcb0a14.svg";